module.exports = __webpack_public_path__ + "img/qcode.118fb77a.png";